var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPolicyExpired = function SvgPolicyExpired(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94857 0.833374C4.57462 0.833374 4.27148 1.13651 4.27148 1.51046V5.30212C4.27148 5.67607 4.57462 5.97921 4.94857 5.97921C5.32252 5.97921 5.62565 5.67607 5.62565 5.30212V1.51046C5.62565 1.13651 5.32252 0.833374 4.94857 0.833374Z",
    fill: "#F24E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94857 7.60421C4.57462 7.60421 4.27148 7.90734 4.27148 8.28129C4.27148 8.65524 4.57462 8.95837 4.94857 8.95837C5.32252 8.95837 5.62565 8.65524 5.62565 8.28129C5.62565 7.90734 5.32252 7.60421 4.94857 7.60421Z",
    fill: "#F24E3F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPolicyExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/policy-expired.3baf492e.svg";
export { ForwardRef as ReactComponent };